import React from "react";
import { Facebook, Instagram } from "lucide-react";
import { FACEBOOK_URL, TIKTOK_URL, INSTAGRAM_URL } from "../lib/utils";

const TikTokIcon = ({ className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

// Floating vertical social rail — desktop only, discreet, always-on
export default function FloatingSocials() {
  const items = [
    { Icon: Facebook, url: FACEBOOK_URL, label: "Facebook Paintball Aventures 35", testid: "floating-facebook" },
    { Icon: Instagram, url: INSTAGRAM_URL, label: "Instagram Paintball Aventures 35", testid: "floating-instagram" },
    { Icon: TikTokIcon, url: TIKTOK_URL, label: "TikTok Paintball Aventures 35", testid: "floating-tiktok" },
  ];

  return (
    <aside
      data-testid="floating-socials"
      aria-label="Réseaux sociaux Paintball Aventures 35"
      className="hidden md:flex fixed right-4 top-1/2 -translate-y-1/2 z-40 flex-col gap-2 p-1.5 bg-white/85 backdrop-blur-md border-2 border-black shadow-[0_6px_0_-2px_#E91E63]"
    >
      <span className="font-mono text-[8px] font-bold uppercase tracking-[0.2em] text-[#E91E63] text-center py-1">
        Suivez
      </span>
      {items.map(({ Icon, url, label, testid }) => (
        <a
          key={testid}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={label}
          data-testid={testid}
          className="w-9 h-9 inline-flex items-center justify-center text-black hover:bg-[#E91E63] hover:text-white transition-colors"
        >
          <Icon className="w-4 h-4" />
        </a>
      ))}
    </aside>
  );
}
